export const PAYROLL_COMPANIES = {
  "Fondo Manpower": "100",
  "Manpower Mision Quincenal-Semanal": "100",
  "Manpower Mision Mensual": "101",
  "Procemco Planta": "102",
  "CAF Planta": "103",
  "Scribe Planta": "105",
  "Unoa Planta": "106",
  "Pronto Rental": "107",
  "Dexco Planta": "109",
  "Planta Manpower": "112",
  "Ticsa Planta": "114",
  "Maneplanta": "115",
  "Arthrex Planta": "116",
  "Plan Rombo Planta": "118",
  "Glory Global": "119",
  "Ant Gold Planta": "121",
  "QuimtiaPlanta": "122",
  "Nuvant Global": "123",
  "Edelman Colombia SAS": "124",
  "GHL Opco Planta": "125",
  "GHL Logistica Planta": "126",
  "RCI Colombia Planta": "127",
  "Mobileza Lease Planta": "128",
  "GHL Hotelera": "130",
  "Vitaa Planta": "132",
  "Fudes": "133",
  "Colosal": "134",
  "Samsung": "135",
  "Fibtex": "136",
  "Explomin": "137",
  "Ingrill Planta": "139",
  "Instafloor": "140",
  "Prestige": "141",
  "Hogar y Moda": "142",
};